import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';

import { ConnectedMetricValuePillWrapper } from '../../ConnectedMetricValuePill';
import { MetricUpdatedCellFormatter } from '../../MetricUpdatedCellFormatter';

export function MetricValueCell(): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function PlainTextCell(props: BodyCell.Props) {
        return <ConnectedMetricValuePillWrapper row={props.row}/>;
      }
  );
}

export function MetricUpdatedCell(): React.StatelessComponent<BodyCell.Props> {
  return MetricUpdatedCellFormatter();
}
